import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/common/Grid/GridItem.jsx";
import GridContainer from "components/common/Grid/GridContainer.jsx";
import Table from "material-table";
import Button from "components/common/CustomButtons/Button.jsx";
import Card from "components/common/Card/Card.jsx";
import CardHeader from "components/common/Card/CardHeader.jsx";
import CardBody from "components/common/Card/CardBody.jsx";
import ViewSupplyHistory from "components/afrijula/AllDetails/SupplierHistory.jsx";
import $ from "jquery";
import cookies from "react-cookies";
import baseUrl from "assets/js/config/const.js";
import SupplierInvoice from "components/afrijula/AddForm/SupplierInvoice_v2.jsx";
import {getString, currencyFormat, dateFormat, currencyValue, compileQuery} from "assets/js/utils/utils.js";
import AddSupplier from "components/afrijula/AddForm/AddingSupplier.jsx"
import {displaySuccess,displayError} from "../../../assets/js/utils/utils";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    }
};

class SupplierDetails extends React.Component{
    constructor(props) {
        super(props);

        this.tableRef = React.createRef();
    }

    state = this.props.state || {

        addSuppInv: false,
        back: false,
        historyDetails: false,
        supplierInvoiceData: null,
        selectedInvoices: [],

        header : [
            {title: getString().date, field: 'due_date',render: rowData => dateFormat(rowData.due_date)},
            {title: getString().inv_number, field: 'number'},
            {title: getString().total, field: 'total',render: rowData => currencyFormat(rowData.total)},
            {title: getString().balance, field: 'balance',render: rowData => currencyFormat(rowData.balance)}
        ],
        rowCount:0,
        tablePage: 1,
        today: '',
        invoiceSum: 0,

        supplierData: this.props.callerData,

        callerName: this.props.callerName,
        callerState: this.props.callerState,
        callerProps: this.props.callerProps,
        editsupplier: false,
    };

    rowSelect = (event, colData)  => {
        let id = colData._id.$oid;
        let _this = this;

        $.ajax({
            method: "GET",
            url: baseUrl+"/afrijula/suppliers/invoice/"+id,
            dataType: "json",
            headers:{"Authorization":"token "+cookies.load("token"), "UserProfile":cookies.load("profile"),"UserKey":cookies.load('User-Key')},
            success: function (result) {
                _this.setState({
                    supplierInvoiceData: result
                });
            }
        });

    };

    selectedChange  = (rows) => {
        this.updateSelected(rows)
    };

    updateSelected = (rows) => {

        let invoices = this.state.selectedInvoices;
        invoices.splice(0,invoices.length);

        rows.forEach(function(item){
            invoices.push(item);

        });

        this.setState({selectedInvoices: invoices});

    };

    addSupplierInv = () => {
        this.setState({addSuppInv: true});
    };


    loadData = (query,resolve,reject) => {
        const filter = ":supplier_id => '"+this.state.supplierData._id.$oid+"'";

        let url = compileQuery(query, (baseUrl + "/afrijula/suppliers/invoice"),
            ["due_date","number","total","balance","id"], [{"by":"desc","attr":"date"}],
            "Afrijula::Suppliers::Invoice",null,filter);

        fetch(url, {dataType: "json",
            headers:{"Authorization":"token "+cookies.load("token"), "UserProfile":cookies.load("profile"),"UserKey":cookies.load('User-Key')}})
            .then(response => {return response.json()})
            .then(result => {
                resolve({
                    data: result.data,
                    page: query.page,
                    totalCount: result.total
                })
            });
    };

    getProps = () =>{
        return this.props.returningProps || this.props;
    };

    updateCback = (bal,after_delete=false) => {
        let data = this.state.supplierData;
        if(after_delete){
            let balance = currencyValue(data.current_balance,false)+currencyValue(bal,false)
            data.current_balance = balance;
        }else{
            data.current_balance = bal;
        }
        this.setState({supplierData: data});
    };

    editSupplier = () => {
        this.setState({
            editsupplier: true
        })
    };

    closeEditSupplier = () =>{
        this.setState({
            editsupplier: false
        })
    };

    updateSupplierData = (data) =>{
        let _supplier = this.state.supplierData;
        _supplier.name = data.name;
        _supplier.billing_address = data.billing_address;
        _supplier.phone_number = data.phone_number;
        _supplier.contact_person = data.contact_person;
        _supplier.shipping_address = data.shipping_address;
        _supplier.email = data.email;
        _supplier.country = data.country;
        this.setState({
            customerData: _supplier
        })
    };

    deleteInvoice = (data) => {
        if(data === undefined || data === null || data.length != 1){
            displayError("You must select only one item");
            return;
        }
        if(window.confirm("Are you sure you want to delete invoice?")){
            let _this = this;
            $.ajax({
                method: "DELETE",
                url: baseUrl+"/afrijula/suppliers/invoice/"+data[0]._id.$oid,
                dataType: "json",
                headers:{"Authorization":"token "+cookies.load("token"), "UserProfile":cookies.load("profile"),"UserKey":cookies.load('User-Key')},
                success: function (result) {
                    _this.tableRef.current && _this.tableRef.current.onQueryChange()
                    displaySuccess(result.success)
                },error: function(error){
                    displayError(error.responseText);
                }
            });
        }
    }

    render() {

        if(this.state.back){
            let ChildComponent = this.state.callerName;
            return <ChildComponent state={this.state.callerState}  returningProps={this.state.callerProps}/>
        }
        if(this.state.supplierInvoiceData){
            let data = this.state.supplierInvoiceData;
            data.supplier_name = this.state.supplierData.name;
            this.state.supplierInvoiceData = null;
            return <ViewSupplyHistory invoiceData = {data} callerName = {SupplierDetails} callerProps = {this.getProps()} callerState = {this.state} updateCback={this.updateCback.bind(this)}/>
        }
        if(this.state.addSuppInv){
            this.state.addSuppInv = false;
            return <SupplierInvoice supplierData={this.state.supplierData} callerName = {SupplierDetails} callerProps = {this.getProps()} callerState = {this.state} />
        }

        else{

            return (
                <div style={{marginTop: -40}}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={9}>
                                    <Button xs={12} sm={4} md={4} color="success" onClick={this.addSupplierInv.bind(this)}
                                            style={{backgroundColor: "#4caf50", margin: ".3125rem 1px", minWidth: "auto",
                                                minHeight:"auto",fontSize: "12px",color: "#ffffff",  padding: "12px 30px",borderRadius: "3px", verticalAlign: "middle"}}
                                    ><i className="material-icons">add</i> {getString().new_invoice}</Button>
                                    <Button xs={12} sm={4} md={4} color="warning" onClick={this.editSupplier.bind(this)}
                                            style={{backgroundColor: "#ff9800", margin: ".3125rem 1px", minWidth: "auto",
                                                minHeight:"auto",fontSize: "12px",color: "#ffffff",  padding: "12px 30px",borderRadius: "3px", verticalAlign: "middle"}}
                                    ><i className="material-icons">edit</i>
                                        {getString().edit}
                                    </Button>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={3}>
                                    <Button color="danger" onClick={() => {this.setState({back: true})}}
                                            style={{backgroundColor: "#f44336",margin: ".3125rem 1px", float: 'right', minWidth: "auto", minHeight:"auto",
                                                padding: "12px 30px",borderRadius: "3px", color:"#ffffff" }}
                                    >{getString().back}
                                    </Button>
                                </GridItem>
                            </GridContainer>
                        </GridItem>

                    </GridContainer>
                    {(this.state.editsupplier) ? <AddSupplier supplierData={this.state.supplierData}
                                                              callerProps={this.getProps()} callerState = {this.state} callerName={SupplierDetails}
                                                              closeEdit =  {this.closeEditSupplier} editSupplier={true} updateMe={this.updateSupplierData.bind(this)}
                        /> :
                        <GridContainer>
                            <GridItem xs={12} sm={6} md={6}>
                                <Card>
                                    <CardHeader color="primary">
                                        <h4 >{getString().profile}</h4>
                                    </CardHeader>

                                    <CardBody>
                                        <form>
                                            <GridContainer>

                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p><b>{getString()._name}:</b> <b>{this.state.supplierData.name}</b></p>
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p><b>{getString().phone}:</b> <b>{this.state.supplierData.phone_number}</b></p>

                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p><b>{getString().email}:</b> <b>{this.state.supplierData.email}</b></p>

                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p><b>{getString().contact_person}:</b> <b>{this.state.supplierData.contact_person}</b></p>

                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p><b>{getString().shipping_address}:</b> <b>{this.state.supplierData.shipping_address}</b></p>
                                                </GridItem>

                                            </GridContainer>
                                        </form>
                                    </CardBody>

                                </Card>
                            </GridItem>

                            <GridItem xs={12} sm={6} md={6}>
                                <Card>
                                    <CardHeader color="success">
                                        <h4 >{getString().supplier_account}</h4>
                                    </CardHeader>

                                    <CardBody>
                                        <form>
                                            <GridContainer>

                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p><b> {getString().country}:</b> <b>{this.state.supplierData.country}</b></p>
                                                </GridItem>

                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p><b>{getString().balance}:</b> <b>{currencyFormat(this.state.supplierData.current_balance)}</b></p>
                                                </GridItem>

                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p><b>{getString().billing_address}:</b> <b>{this.state.supplierData.billing_address}</b></p>
                                                </GridItem>
                                            </GridContainer>

                                        </form>
                                    </CardBody>

                                </Card>
                            </GridItem>
                        </GridContainer>
                    }
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="warning">
                                    <h4 >{getString().supply_history}</h4>

                                </CardHeader>
                                <Table
                                    tableRef={this.tableRef}
                                    data={query=>new Promise((resolve,reject) => {
                                        this.loadData(query,resolve,reject);
                                    })}
                                    columns={this.state.header}
                                    onRowClick={this.rowSelect}
                                    onSelectionChange={(rows) => this.selectedChange(rows)

                                    }
                                    options={{
                                        exportButton: true,filtering: true,
                                        grouping:true,sorting:true, search:false,
                                        selection:true,showTitle:false,
                                        pageSize:15
                                    }}
                                    actions={[
                                        {
                                            icon: 'refresh',tooltip: 'Refresh',isFreeAction: true,
                                            onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
                                        },
                                        {
                                            icon: 'delete',tooltip: 'Delete invoice',
                                            onClick: (evt, data) => {this.deleteInvoice(data);}
                                        }
                                    ]}
                                />
                            </Card>

                        </GridItem>
                    </GridContainer>
                </div>
            );
        }
    }
}


export default withStyles(styles)(SupplierDetails);
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            